import { BASE_URL } from "../../../../config"

// ✔ Dohvatanje svih tabela
export const getTables = async (host, port, database, user, password) => {
    const url = `${BASE_URL}/api/table-data?host=${host}&port=${port}&database=${database}&username=${user}&password=${password}`;

    const response = await fetch(url, {
        method: 'GET',
        mode: 'cors',
    });

    if (response.ok) {
        const data = await response.json();
        return data;
    } else {
        console.error(`Error: ${response.status} ${response.statusText}`);
        return null;
    }
};

// ✔ Dohvatanje podataka za konkretnu tabelu
export const readTable = async (host, port, database, user, password, tableName) => {
    const url = `${BASE_URL}/api/table-data/${tableName}?host=${host}&port=${port}&database=${database}&username=${user}&password=${password}`;

    const response = await fetch(url, {
        method: 'GET',
        mode: 'cors',
    });

    if (response.ok) {
        const data = await response.json();
        return data; // data.columns, data.data
    } else {
        console.error(`Error: ${response.status} ${response.statusText}`);
        return null;
    }
};
